
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/appsflyer",
      function () {
        return require("private-next-pages/destinations/appsflyer.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/appsflyer"])
      });
    }
  